// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_42-0";